import {Box, Grid, Theme} from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import React, {FC, useCallback, useEffect, useRef} from 'react';
import {useFormContext} from 'react-hook-form';
import {useSelector} from 'react-redux';
import product4IllustrationImg from '../../../../assets/products/product-4/product4Illustration.png';
import {localized, localizedInterpolation} from '../../../../i18n/i18n';
import {AppState} from '../../../../state/store';
import {
  getUnitLenghtByCulture,
  getValueLengthWithUnitByCulture,
} from '../../../../utilities/helpers/culture-settings-helper';
import {manuelNumberCheck} from '../../../../utilities/helpers/form-helper';
import {ImageRow} from '../../../components/custom-components/configuration/dynamic-components/image-row';
import {ValueRangeInput} from '../../../components/custom-components/configuration/dynamic-components/value-range-input';
import {worktopDepth, worktopLength} from '../configuration-constants';
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    grid: {
      width: '686px',
      [theme.breakpoints.down('lg')]: {
        width: '500px',
      },
    },
    gridItem: {
      height: '140px',
    },
  }),
);

export const Product4Step1: FC = React.memo(() => {
  const classes = useStyles();
  const {unitsId} = useSelector((store: AppState) => store.urlSettingsReducer.cultureUrlParameters);
  const myRef = useRef<null | HTMLDivElement>(null);
  const formContext = useFormContext();

  useEffect(() => {
    if (myRef && myRef.current) {
      myRef.current.scrollIntoView({block: 'end'});
    }
  }, []);

  useEffect(() => {}, [unitsId]);

  const between1400And3000 = useCallback(
    (event: any) => {
      manuelNumberCheck(
        event.target.name,
        event.target.value,
        getUnitLenghtByCulture(unitsId, '1400'),
        getUnitLenghtByCulture(unitsId, '3000'),
        unitsId,
        formContext,
      );
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [unitsId],
  );

  const between700And1000 = useCallback(
    (event: any) => {
      manuelNumberCheck(
        event.target.name,
        event.target.value,
        getUnitLenghtByCulture(unitsId, '700'),
        getUnitLenghtByCulture(unitsId, '1000'),
        unitsId,
        formContext,
      );
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [unitsId],
  );

  return (
    <>
      <Box display="flex" justifyContent="center" alignItems="center" sx={{flexGrow: 1}}>
        <Grid container spacing={2} className={classes.grid}>
          <Grid ref={myRef} container spacing={6}>
            <ImageRow imgString={product4IllustrationImg} />
          </Grid>

          <Grid container spacing={6} className={classes.gridItem}>
            <ValueRangeInput
              formName={worktopLength}
              minValue={'1400'}
              maxValue={'3000'}
              textInputLabel={localized('LengthOfTheTableTop') + ' (A)'}
              tooltipLabel={localizedInterpolation('ToolTipProduct4Step1_1', {
                value1: getValueLengthWithUnitByCulture(unitsId, '1400'),
                value2: getValueLengthWithUnitByCulture(unitsId, '3000'),
              })}
              formOnChange={between1400And3000}
            />
          </Grid>

          <Grid container spacing={6} className={classes.gridItem}>
            <ValueRangeInput
              formName={worktopDepth}
              minValue={'700'}
              maxValue={'1000'}
              textInputLabel={localized('DepthOfTheTableTop') + ' (B)'}
              tooltipLabel={localizedInterpolation('ToolTipProduct4Step1_2', {
                value1: getValueLengthWithUnitByCulture(unitsId, '700'),
                value2: getValueLengthWithUnitByCulture(unitsId, '1000'),
              })}
              formOnChange={between700And1000}
            />
          </Grid>
        </Grid>
      </Box>
    </>
  );
});
